import {useState, useEffect} from "react";
import {SwalAlertClass} from "core/swalClass";
import {Chart as ChartJS, ArcElement, Tooltip, Legend} from "chart.js";
import {Doughnut} from "react-chartjs-2";
import WasteSelectorTypes from "components/waste-icons/WasteSelectorTypes";
import axiApi from "ApiCaller";

ChartJS.register(ArcElement, Tooltip, Legend);

const ContainersFraction = () => {
  const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
  const [data, setData] = useState([]);
  const [labels, setLabels] = useState([]);
  const [colors, setColors] = useState([]);
  const [total, setTotal] = useState(0);

  const DataGraph = {
    labels: labels,
    datasets: [
      {
        label: "Número de contenedores",
        data: data,
        backgroundColor: colors,
        hoverOffset: 10,
      },
    ],
  };
  const OptionsGraph = {
    plugins: {
      legend: {
        position: "top",
        labels: {
          usePointStyle: true,
          pointStyle: "rect",
          font: {
            size: 10,
          },
        },
      },
      title: {
        display: true,
        text: "Nº contenedores por fracción",
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem) => {
            let value = tooltipItem.raw;
            let percentage = ((value / total) * 100).toFixed(2);
            // return `${percentage}%`;
            return `${tooltipItem.label}: ${value} (${percentage}%)`;
          },
        },
      },
    },
  };

  useEffect(() => {
    axiApi
      .get("/api/home/fraction/")
      .then((resp) => {
        if (resp.data.status) {
          let names = {};
          let labels = [];
          let values = [];
          let backgroud = [];
          let total = 0;
          resp.data.choices.forEach(([key, value]) => {
            names[key] = value;
          });
          resp.data.containers.forEach((waste, idx) => {
            labels.push(names[waste.waste_type]);
            values.push(waste.count);
            backgroud.push(
              WasteSelectorTypes.getBackgroundColor(waste.waste_type)
            );
            total += waste.count;
          });
          setLabels(labels);
          setData(values);
          setColors(backgroud);
          setTotal(total);
        } else {
          Alert.error(
            "Error in ContainerFraction.API",
            "Se ha encontrado un error en la carga del mapa."
          );
        }
      })
      .catch((error) => {
        console.log(error);
        Alert.error(
          "Error in ContainerFraction.API",
          "Se ha encontrado un error en la carga del mapa."
        );
      });
  }, []);

  return (
    <div className="border pb-3">
      <Doughnut data={DataGraph} options={OptionsGraph} />
    </div>
  );
};

export default ContainersFraction;
